import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class RoleSecurityService {
    constructor(private readonly authenticationService: AuthenticationService) {}

    private userHasRole(role: string): boolean {
        return this.authenticationService.getUserRoles().includes(role);
    }

    userCanView(key: string): boolean {
        return this.userHasRole(`view-${key}`);
    }
}
